import React from 'react';
import { useLogo } from '../context/ThemeContext';

export const ThemedLogo = ({ src = '/logo.png', alt = 'NexUacademy', ...props }) => <img src={useLogo(src)} alt={alt} {...props} />;

export default ThemedLogo;
